import data from './emoji/data.json'
import type { SlackEmojiMap } from '@assembly/slack'

export const EMOJI_NAMES: Record<string, string> = data.names
export const EMOJI_CATEGORIES: { name: string; emojis: string[] }[] = data.categories

const SKIN_TONES = ['', '', '\u{1F3FB}', '\u{1F3FC}', '\u{1F3FD}', '\u{1F3FE}', '\u{1F3FF}']

export interface ResolvedEmoji {
  char?: string
  url?: string
}

/** Resolves a Slack emoji name to a unicode character or a custom emoji image. */
export function resolveEmoji(name: string, custom?: SlackEmojiMap, skinTone?: number): ResolvedEmoji | null {
  let n = name
  for (let depth = 0; depth < 4; depth++) {
    const value = custom?.[n]
    if (value?.startsWith('alias:')) {
      n = value.slice(6)
      continue
    }
    if (value) return { url: value }
    break
  }
  const toneMatch = /^(.+)::skin-tone-(\d)$/.exec(n)
  if (toneMatch) {
    n = toneMatch[1]
    skinTone = Number(toneMatch[2])
  }
  const char = EMOJI_NAMES[n]
  if (!char) return null
  if (skinTone && skinTone > 1) {
    const [first, ...rest] = [...char]
    return { char: first + SKIN_TONES[skinTone] + rest.join('') }
  }
  return { char }
}

export const QUICK_REACTIONS = ['white_check_mark', 'eyes', 'raised_hands', '+1', 'joy', 'heart']

/** Prefix/substring search over standard and custom emoji names. */
export function searchEmoji(query: string, custom?: SlackEmojiMap, limit = 40): string[] {
  const q = query.toLowerCase()
  const all = [...Object.keys(custom ?? {}), ...Object.keys(EMOJI_NAMES)]
  const starts: string[] = []
  const contains: string[] = []
  const seen = new Set<string>()
  for (const name of all) {
    if (seen.has(name)) continue
    seen.add(name)
    if (name.startsWith(q)) starts.push(name)
    else if (name.includes(q)) contains.push(name)
    if (starts.length >= limit) break
  }
  return [...starts, ...contains].slice(0, limit)
}

const RECENT_KEY = 'assembly.recentEmoji'

export function recentEmoji(): string[] {
  try {
    return JSON.parse(localStorage.getItem(RECENT_KEY) ?? '[]')
  } catch {
    return []
  }
}

export function rememberEmoji(name: string) {
  try {
    const next = [name, ...recentEmoji().filter((n) => n !== name)].slice(0, 24)
    localStorage.setItem(RECENT_KEY, JSON.stringify(next))
  } catch {
    /* storage unavailable */
  }
}
